import React from 'react';

function BooleanIcon({ value }: { value: boolean }) {
    const icon = value ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline';
    const iconClass = value ? 'text-success' : 'text-danger';

    return <i className={`boolean-icon mdi ${icon} ${iconClass}`} />;
}

export default BooleanIcon;
